// extracted by mini-css-extract-plugin
export var active = "contactForm-module--active--lKOpZ";
export var form = "contactForm-module--form--ZUqIq";
export var submitButton = "contactForm-module--submit-button--MqKVY";